module.exports = __webpack_public_path__ + "img/pingandeng.6931e9a7.png";